import * as React from 'react';
import { useContext, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { getAvailabilityColor, getEsHs } from '../../utility/api-utilities';
import CompareMap from '../info/compare-map';
import { AppContext } from '../school-search-app';
import { PAGE_MODE, SCHOOL_TYPE } from '../../interfaces';
import { getPageProperties } from '../../services/cps-school-api';

export interface ICompareSchools {
    schools: any[];
    show: boolean;
    close: () => void;
    selectSchool: (id) => void;
    onDeleteSchool: (id) => void;
}

function CompareSchools({ schools, show, close, selectSchool, onDeleteSchool }: ICompareSchools) {

    const [compareSchools, setCompareSchools] = useState([])
    const appContext = useContext(AppContext);


    React.useEffect(() => {
        setCompareSchools(schools);
    }, [schools])
    const click = (i) => {
        let s = [...compareSchools];
        s.splice(i, 1);
        setCompareSchools(s);
        if (s.length == 0) {
            close();
        }
    }

    const closeMe = () => {
        setCompareSchools([]);
        close();
    }
    
    let headers;
    if (appContext.mode == PAGE_MODE.SUMMER_PROGRAMM) {
        headers = <tr>
            <th></th>
            <th>Grade</th>
            <th>Duration</th>
            <th>Time</th>
            <th>Days</th>
        </tr>
    }
    else if (appContext.mode == PAGE_MODE.GOCPS) {
        headers = <tr>
            <th>School Info</th>
            <th>Grades Served</th>
            <th>Number of Students</th>
            <th>Programs</th>
            {/*<th>Seats</th>*/}
            <th></th>
        </tr>
    }
    else {
        headers = <tr>
            <th>School Info</th>
            <th>Ages</th>
            <th>Seats</th>
            <th>School Day</th>
            <th>Durations</th>
            <th>Excelerate Quality Rating</th>
        </tr>;
    }

    const moreInfoHTML = (school) => {
        if (appContext.profileRedirectUrl) {
            const url = '' + appContext.profileRedirectUrl + school._epi.id;
            return <a className="" target="_blank" href={url}> More Info </a>
        }

        return <a className="" onClick={() => selectSchool(school._epi.id)} > More Info </a>
    }

    const renderPrekSchool = (school, i) => {
        const durationValues = [
            school._epi.schoolYear ? school._epi.schoolYear : null,
            school._epi.fullYear ? school._epi.fullYear : null
        ].filter(x => x != null);

        const dayValues = [
            school._epi.fullDayProgram ? school._epi.fullDayProgram : null,
            school._epi.partDayProgram ? school._epi.partDayProgram : null
        ].filter(x => x != null);

        const celSchoolInfo = <>
            <p>{school._epi.address}</p>
            <p>{school._epi.phoneNumber}</p>
            <p><a className="" onClick={() => selectSchool(school._epi.id)}>More Info</a></p>
        </>;

        const info = celSchoolInfo;

        let rowClass = 'cel';
        if (appContext.mode == PAGE_MODE.PREK && school.type == SCHOOL_TYPE.CPS) {
            rowClass = 'cps';
        }

        return <>
            <tr key={`compare${i}r1${school._epi.id}`} className={rowClass} >
                <td colSpan={6}>
                    <div className="close-row">
                        <h3>{school._epi.title}</h3>
                        <button className={`remove-school`} onClick={() => { click(i); onDeleteSchool(school._epi.id) }}>
                            &times;
                        </button>
                    </div>
                </td>
            </tr>
            <tr key={`compare${i}r2${school._epi.id}`}>
                <td>
                    {info}
                </td>

                <td>
                    {school._epi.agesServed ? 'Ages ' + school._epi.agesServed : ''}
                </td>
                <td>
                    <span className={`circle ${getAvailabilityColor(school._epi.availability)}`}></span> {school._epi.availability}
                </td>
                <td>
                    {dayValues.map(val => <div key={`val-${val}`}>{val}</div>)}
                </td>
                <td>
                    {durationValues.map(val => <div key={`val-${val}`}>{val}</div>)}
                </td>
                <td>
                    {school._epi.qualityRating ? school._epi.qualityRating : 'Unknown'}
                </td>
            </tr>
        </>
    }

    const renderGocpsSchool = (school, i) => {
        const grade = getEsHs(school)

        return <>
            <tr key={`compare${i}r1${school._epi.id}`} className={`${grade}`} >
                <td colSpan={6}>
                    <div className="close-row">
                        <h3>{school._epi.title}</h3>
                        <button className={`remove-school`} onClick={() => click(i)}>
                            &times;
                        </button>
                    </div>
                </td>
            </tr>
            <tr key={`compare${i}r2${school._epi.id}`}>
                <td>
                    <p>{school._epi.address}</p>
                    <p>{school._epi.phoneNumber}</p>
                </td>

                <td>
                    {school._epi.gradesOffered}
                </td>
                <td>
                    {school._epi.studentCount}
                </td>
                <td>
                    {school._epi.programs && school._epi.programs.length ? school._epi.programs.join(', ') : 'Unavailable'}
                </td>
                {/*<td>*/}
                {/*    <span className={availabilityIcon(school._epi.availability)}></span> {school._epi.availability}*/}
                {/*</td>*/}
                <td>
                    <p>{moreInfoHTML(school)}</p>
                </td>
            </tr>
        </>
    }

    const renderSchoolPrograms = (school, i) => {
        const durationValues = [
            school._epi.schoolYear ? school._epi.schoolYear : null,
            school._epi.fullYear ? school._epi.fullYear : null
        ].filter(x => x != null);

        const dayValues = [
            school._epi.fullDayProgram ? school._epi.fullDayProgram : null,
            school._epi.partDayProgram ? school._epi.partDayProgram : null
        ].filter(x => x != null);

        return <>
            <tr key={`compare${i}r1${school._epi.id}`} className={'prog'} >
                <td colSpan={5}>
                    <div className="close-row">
                        <h3>{school._epi.title}</h3>
                        <button className={`remove-school`} onClick={() => { click(i); onDeleteSchool(school._epi.id) }}>
                            &times;
                        </button>
                    </div>
                </td>
            </tr>
            <tr key={`compare${i}r2${school._epi.id}`}>
                <td>
                    {school._epi.address}{school._epi.phoneNumber ? <br>{school._epi.phoneNumber}</br> : <></>}
                </td>
                <td>
                    2  {/*{school._epi.agesServed ? 'Ages ' + school._epi.agesServed : ''}*/}
                </td>
                <td>
                    3  {/*    <span className={`circle ${getAvailabilityColor(school._epi.availability)}`}></span> {school._epi.availability}*/}
                </td>
                <td>
                    4        {/*{dayValues.map(val => <div key={`val-${val}`}>{val}</div>)}*/}
                </td>
                <td>
                    5         {/*{durationValues.map(val => <div key={`val-${val}`}>{val}</div>)}*/}
                </td>
            </tr>
        </>
    }

    return <div className="compare-schools bs-shim modal-page">
        <div className="page-close-bar compare">
            <div className="shortName">Compare Schools</div>
            <button className="btn close-btn" onClick={closeMe}></button>
        </div>
        <div className="padded-page-header">
            <CompareMap schools={compareSchools} />
        </div>
        <div className="table-scrolling-wrapper">
            <table>
                <thead>
                    {headers}
                </thead>
                <tbody>
                    {compareSchools.map((school, i) => {
                        if (appContext.mode == PAGE_MODE.GOCPS) {
                            return renderGocpsSchool(school, i);
                        }
                        if (appContext.mode == PAGE_MODE.SUMMER_PROGRAMM) {
                            return renderSchoolPrograms(school, i);
                        }
                        else {
                            return renderPrekSchool(school, i);
                        }
                    })}
                </tbody>
            </table>
        </div>
    </div>
}

export default CompareSchools;